import axios from "axios";
import qs from "qs";
import { baseUrl } from "../config/EnVariables";
// const baseUrl = "http://localhost:8081/api";
const token = localStorage.getItem("access_token");
const user = JSON.parse(localStorage.getItem("user"));
const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json", // Assuming you're sending JSON data
};

const Floor = {
  getAllFloors: () =>
    axios.get(`${baseUrl}/building-floors/?branchId=${user?.branchId}`, {
      headers: headers,
    }),

  getOne: (ID) =>
    axios.get(`${baseUrl}/building-floors/${ID}`, { headers: headers }),

  getAccounts: () => axios.get("/transfer/accounts"),

  addFloor: (data) =>
    axios.post(`${baseUrl}/building-floors/?branchId=${user.branchId}`, data, {
      headers: headers,
    }),

  update: (data) =>
    axios.put(`${baseUrl}/building-floors`, data, { headers: headers }),

  getByMember: (ID, pagination, date) =>
    axios.get(
      `/transfer/member/${ID}?${qs.stringify(pagination)}&${qs.stringify(date)}`
    ),

  remove: (id) =>
    axios.delete(`${baseUrl}/building-floors/${id}`, { headers: headers }),
};

export default Floor;
